<template>
  <div>
    <page-header>
      <template #breadcrumbs> Пользователи </template>
      <h2>Пользователи</h2>
      <template #actions>
        <div class="actions">
          <button-component
            class="mx-2"
            v-if="canImportExcel"
            :disabled="importInProgress"
            @click="importExcel()"
          >
            <template v-if="!importInProgress">Загрузить из Excel</template>
            <template v-else>Загрузка...</template>
          </button-component>
          <button-component v-if="canEdit" @click="editCard(0)">
            Создать
          </button-component>
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page">
        <template v-if="page.items.length">
          <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="50px"></th>
                  <th class="text-center">ID</th>
                  <th>ФИО</th>
                  <th>Организация</th>
                  <th>Логин</th>
                  <th>E-mail</th>
                  <th>Телефон</th>
                  <th>Заблокирован</th>
                  <th>Дата создания</th>
                  <th>Дата изменения</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in page.items"
                  :key="item.id"
                  v-on:dblclick="editCard(item.id)"
                >
                  <td>
                    <menu-component class="actions" :actions="actions(item)" />
                  </td>
                  <td class="text-center">{{ item.id }}</td>
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.organizations }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phoneNumber }}</td>
                  <td>
                    <input
                      type="checkbox"
                      v-model="item.isDisabled"
                      :disabled="true"
                    />
                  </td>
                  <td>{{ $momentFormat(item.created, "DD.MM.YYYY HH:mm") }}</td>
                  <td>
                    {{ $momentFormat(item.modified, "DD.MM.YYYY HH:mm") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="page.pagesTotal > 1">
            <Pagination
              :page-count="page.pagesTotal"
              :current-page="page.pageNumber"
              @change="onPageChange($event)"
            />
          </div>
          <div>
            <PageCounter
              :isFiltered="isFiltered"
              :totalCount="totalCount"
              :filteredCount="page.itemsTotal"
            />
          </div>
        </template>
        <template v-else>
          <EmptyListMessage />
        </template>
      </template>

      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <UsersFilter
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
        <modal-component
          v-if="modals.importUsers"
          title="Импорт пользователей"
          size-class=""
          @close="modals.importUsers = false"
        >
          <import-users
            v-on:doimport="doImport"
            @close="modals.importUsers = false"
          />
        </modal-component>
      </section>
    </section>
  </div>
</template>

<script>
import API from "../api/users";
import UsersFilter from "../components/UsersFilter";
import "leaflet/dist/leaflet.css";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PageHeader from "@/common/components/page/PageHeader";
import IconComponent from "@/common/ui/IconComponent";
import EmptyListMessage from "../../../common/components/EmptyListMessage";
import Constants from "../../../common/constants";
import { mapState } from "vuex";
import security from "../../../common/mixins/security";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import userManager from "../../auth/user-manager";
import ModalComponent from "../../../common/ui/ModalComponent";
import ImportUsers from "../components/ImportUsers";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "Users",
  components: {
    ImportUsers,
    ModalComponent,
    MenuComponent,
    EmptyListMessage,
    UsersFilter,
    IconComponent,
    PageHeader,
    ButtonComponent,
    PageCounter,
  },
  mixins: [security, filtermanager],
  created() {
    //загрузить по-умолчанию
    this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
    this.checkPermission(Constants.UserEdit).then((response) => {
      this.canEdit = response.data;
    });
    userManager.getUser().then((user) => {
      this.canImportExcel =
        user.profile.role.indexOf(Constants.AdminRoleId) > -1;
    });
    this.getTotalCount();
    this.loadPage();
  },
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize,
      },
      filters: {
        userName: "",
        email: "",
        surname: "",
        name: "",
        patronymic: "",
        phoneNumber: "",
        roleIds: [],
        isDisabled: null,
        organizationId: 0,
      },
      modals: {
        filter: false,
        importUsers: false,
      },
      canEdit: true,
      isFiltered: false,
      canImportExcel: false,
      importInProgress: false,
      totalCount: 0,
    };
  },
  methods: {
    getTotalCount() {
      const self = this;
      API.search({ pageNumber: 1, pageSize: 1 }).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      let result = [
        {
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.id),
        },
      ];
      if (this.canEdit) {
        result = result.concat([
          {
            title: "Редактировать",
            icon: "pen",
            click: () => {
              if (this.canEdit) this.editCard(item.id);
            },
          },
          {
            title: "Удалить",
            icon: "trash",
            click: () => {
              if (this.canEdit) this.deleteCard(item.id);
            },
          },
        ]);
      }
      return result;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.$router.push({
          query: {
              ...this.$route.query,
              page: pageNumber
            }
      });
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      this.$store.dispatch(
        "admin/users/searchUsers",
        Object.assign(this.filters, this.request)
      );
    },
    viewCard(id) {
      this.$router.push({
        name: "userCard",
        params: { action: "view", id: id },
        query: { page: this.request.pageNumber }
      });
    },
    editCard(id) {
      this.$router.push({
        name: "userCard",
        params: { action: "edit", id: id },
        query: { page: this.request.pageNumber }
      });
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id)
            .then(() => {
              Constants.alert.fire(
                "Удаление",
                "Запись о пользователе удалена.",
                "success"
              );
              this.getTotalCount();
              this.loadPage();
            })
            .catch(() => {
              Constants.alert.fire(
                "Удаление",
                "Ошибка при удалении записи о пользователе.",
                "error"
              );
            });
        }
      });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
    importExcel() {
      this.modals.importUsers = true;
    },
    doImport(file) {
      this.modals.importUsers = false;
      this.importInProgress = true;
      API.importExcel(this.name, file)
        .then((response) => {
          if (response.data.success) {
            Constants.alert.fire("Импорт", response.data.message, "success");
          } else {
            Constants.alert.fire("Импорт", response.data.message, "error");
          }
          this.loadPage();
          this.importInProgress = false;
        })
        .catch((response) => {
          console.log(response);
          Constants.alert.fire(
            "Импорт",
            "Ошибка при импорте пользователей.",
            "error"
          );
          this.importInProgress = false;
        });
    },
  },
  computed: {
    ...mapState({
      page: (state) => state.admin.users.listPage,
    }),
  },
  watch: {
    '$route.query.page': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
</style>
